var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6809 41.9778L9.3599 42C4.22927 42.0047 0.0279892 37.8115 0.0221589 32.6809L3.8874e-06 9.3599C-0.00466032 4.22927 4.18846 0.0279892 9.31908 0.0221589L32.6401 3.8874e-06C37.7707 -0.00466032 41.972 4.18846 41.9778 9.31908L42 32.6401C42.0058 37.7719 37.8115 41.9732 32.6809 41.9778Z",
    fill: "url(#paint0_radial_396_79)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6809 41.9778L9.3599 42C4.22927 42.0047 0.0279892 37.8115 0.0221589 32.6809L3.8874e-06 9.3599C-0.00466032 4.22927 4.18846 0.0279892 9.31908 0.0221589L32.6401 3.8874e-06C37.7707 -0.00466032 41.972 4.18846 41.9778 9.31908L42 32.6401C42.0058 37.7719 37.8115 41.9732 32.6809 41.9778Z",
    fill: "url(#paint1_radial_396_79)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 29.163C16.5007 29.163 12.8381 25.5016 12.8381 21.0006C12.8381 16.4997 16.5007 12.8383 21.0005 12.8383C25.5003 12.8383 29.1628 16.4997 29.1628 21.0006C29.1628 25.5016 25.5003 29.163 21.0005 29.163ZM21.0005 15.1704C17.7857 15.1704 15.1702 17.7858 15.1702 21.0006C15.1702 24.2154 17.7857 26.8309 21.0005 26.8309C24.2153 26.8309 26.8307 24.2154 26.8307 21.0006C26.8307 17.7858 24.2153 15.1704 21.0005 15.1704Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7459 14.0043C30.7119 14.0043 31.495 13.2212 31.495 12.2552C31.495 11.2892 30.7119 10.5061 29.7459 10.5061C28.7799 10.5061 27.9968 11.2892 27.9968 12.2552C27.9968 13.2212 28.7799 14.0043 29.7459 14.0043Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9969 36.1592H14.0043C9.50449 36.1592 5.84192 32.4978 5.84192 27.9969V14.0043C5.84192 9.50332 9.50449 5.84192 14.0043 5.84192H27.9969C32.4967 5.84192 36.1592 9.50332 36.1592 14.0043V27.9969C36.1592 32.4978 32.4967 36.1592 27.9969 36.1592ZM14.0043 8.17402C10.7895 8.17402 8.17402 10.7895 8.17402 14.0043V27.9969C8.17402 31.2117 10.7895 33.8271 14.0043 33.8271H27.9969C31.2117 33.8271 33.8271 31.2117 33.8271 27.9969V14.0043C33.8271 10.7895 31.2117 8.17402 27.9969 8.17402H14.0043Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_396_79",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6134 42.0303) scale(52.3545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_396_79",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.75844 -0.524366) scale(34.7635 23.1629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.ee9dc2d6.svg";
export { ForwardRef as ReactComponent };